import type { TOption } from '@/types/common';

export enum EAccountType {
  BUSINESS = 'partner',
  PERSONAL = 'personal',
}

export enum EYearsOfOperation {
  LTE_10 = 'LTE_10',
  BETWEEN_11_20 = 'BETWEEN_11_20',
  MORE_THAN_20 = 'MORE_THAN_20',
}

export enum EBusinessType {
  PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  PARTNERSHIP = 'PARTNERSHIP',
  CORPORATION = 'CORPORATION',
  LLC = 'LLC',
}

export const YEARS_OF_OPERATION: TOption<EYearsOfOperation>[] = [
  {
    label: 'signUp.yearsOfOperation.lte10',
    value: EYearsOfOperation.LTE_10,
  },
  {
    label: 'signUp.yearsOfOperation.between11and20',
    value: EYearsOfOperation.BETWEEN_11_20,
  },
  {
    label: 'signUp.yearsOfOperation.moreThan20',
    value: EYearsOfOperation.MORE_THAN_20,
  },
];

export const BUSINESS_TYPES: TOption<EBusinessType>[] = [
  {
    label: 'signUp.businessType.proprietorship',
    value: EBusinessType.PROPRIETORSHIP,
  },
  {
    label: 'signUp.businessType.partnership',
    value: EBusinessType.PARTNERSHIP,
  },
  {
    label: 'signUp.businessType.corporation',
    value: EBusinessType.CORPORATION,
  },
  {
    label: 'signUp.businessType.llc',
    value: EBusinessType.LLC,
  },
];
